<template>
  <div>
    <v-card outlined>
      <v-data-table
        :footer-props="{
          'items-per-page-text': 'Số dữ liệu mỗi trang',
          'items-per-page-all-text': 'Tất cả',
          'items-per-page-options': [5, 10, 20, 50, -1]
        }"
        :headers="headers"
        :items="listImportDelivery"
        :page="page"
        :server-items-length="countImportDeliveries"
        :loading="loading"
        :items-per-page="5"
        @update:page="val => updatePagination('page', val)"
        @update:items-per-page="val => updatePagination('itemsPerPage', val)"
        item-value="id"
        disable-sort
      >
        <template v-slot:[`body.prepend`]>
          <tr>
            <td colspan="1"></td>
            <td colspan="1"></td>
            <td colspan="1"></td>
            <td colspan="1">
              <BaseSmallInput
                style="max-width: 100%"
                placeholder="Nhập mã imei"
                v-model="filter.imei_contains"
                @change="searchWithOption"
              />
            </td>
            <td colspan="1"></td>
            <td colspan="1"></td>
            <td colspan="1"></td>
            <td class="text-red text-center">
              <div :style="{ width: '90px' }">
                {{ convertStats(stats) }}
              </div>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </template>
        <template v-slot:[`item.index`]="{ index }">
          {{ (page - 1) * itemsPerPage + index + 1 }}
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <span class="text-ellipsis">{{ item.description }}</span>
              </div>
            </template>
            <span class="white--text text-justify">
              {{ item.description }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <div class="text-blue">{{ item.code }}</div>
        </template>
        <template v-slot:[`item.imei`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <div class="text-blue text-ellipsis">{{ item.imei }}</div>
              </div>
            </template>
            <span class="white--text text-justify">
              {{ item.imei }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-icon v-if="item.status && item.status === 'approve'" color="success">mdi-check-circle</v-icon>
          <v-icon v-else color="red">mdi-help-circle</v-icon>
        </template>
        <template v-slot:[`item.deliveredAt`]="{ item }">
          <div>{{ formatDate(item.deliveredAt) }}</div>
        </template>
        <template v-slot:[`item.notes`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs">
                <span class="text-ellipsis">{{ item.notes }}</span>
              </div>
            </template>
            <span class="white--text text-justify">
              {{ item.notes }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-blue" style="white-space: nowrap;">
            <v-icon
              class="ml-2"
              v-if="$auth.policies['import-checks:update-product']"
              @click="$refs['dialog-product'].openDialog('only', item)"
              color="primary"
              >mdi-pencil</v-icon
            >
          </div>
        </template>
      </v-data-table>
      <DialogEditAuditProduct
        ref="dialog-product"
        @refresh="
          () => {
            $emit('refresh')
          }
        "
      />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'
import BaseSmallInput from '@/components/basic/BaseSmallInput.vue'
import DialogEditAuditProduct from '@/modules/detail-audit-product/DialogEditAuditProduct.vue'
export default {
  name: 'TableListProducts',
  components: {
    BaseSmallInput,
    DialogEditAuditProduct
  },
  props: {
    importOrderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      itemsPerPage: 5,
      page: 1,
      items: [],
      loading: false,
      pagination: {},
      filter: {
        imei_contains: ''
      },
      headers: [
        { text: 'STT', value: 'index', width: '40px', align: 'center' },
        { text: 'Model', value: 'code', width: '120px' },
        { text: 'Mô tả', value: 'description', width: '150px' },
        { text: 'Mã IMEI /Mã Seria', value: 'imei', width: '120px' },
        { text: 'Mã hóa đơn', value: 'billCode', width: '90px' },
        { text: 'Mã phiếu / DO', value: 'doCode', width: '90px', align: 'left' },
        { text: 'Mã đơn / PO', value: 'poCode', width: '90px', align: 'left' },
        { text: 'Đạt tiêu chuẩn / Xác nhận nhập', value: 'status', width: '90px', align: 'center' },
        { text: 'Ngày nhập thực tế', value: 'deliveredAt', width: '90px', align: 'left' },
        { text: 'Ghi chú', value: 'notes', width: '150px', align: 'left' },
        { text: 'Thao tác', value: 'actions', width: '80px', align: 'center' }
      ]
    }
  },
  computed: mapState({
    selectAuditProduct(state) {
      return state['auditProducts'].item
    },
    countImportDeliveries(state) {
      return state['auditProducts'].countImportDeliveries
    },
    listImportDelivery(state) {
      return state['auditProducts'].listImportDelivery
    },
    stats(state) {
      return state['auditProducts'].stats
    }
  }),
  methods: {
    ...mapActions({
      getImportDeliveryProduct: 'auditProducts/getImportDeliveryProduct',
      countImportDeliveryProduct: 'auditProducts/countImportDeliveryProduct',
      getStats: 'auditProducts/getStats'
    }),
    formatDate(dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('DD/MM/YYYY')
    },
    async updatePagination(type, val) {
      try {
        this.loading = true
        const page = type === 'page' ? val : 1
        const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
        const params = {
          ...this.filter,
          _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          importCheck: get(this.selectAuditProduct, 'id'),
          productModel: this.importOrderId
        }
        await this.getImportDeliveryProduct(params)
        this.itemsPerPage = itemsPerPage
        this.page = page
      } catch (e) {
        this.$alert.error('Có lỗi xảy ra!')
      } finally {
        this.loading = false
      }
    },
    async searchWithOption() {
      try {
        this.loading = true
        const query = {
          ...this.filter,
          importCheck: get(this.selectAuditProduct, 'id'),
          productModel: this.importOrderId
        }
        await this.getImportDeliveryProduct({ ...query, _start: 0, _limit: this.itemsPerPage })
        await this.countImportDeliveryProduct(query)
        await this.getStats({ type: 'detail', ...query })
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.loading = false
      }
    },
    convertStats(stats) {
      if (!stats) return '--/--'
      if (stats.totalQuantity) return `${stats.approveQuantity || 0}/${stats.totalQuantity}`
      return '--/--'
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'src/assets/importOrder/table-list-product.scss';
.text-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.text-blue {
  color: #0d47a1;
}

.text-red {
  color: red;
}
</style>
